import React from 'react'
import styled from 'styled-components'
import { colors, layout, bp } from '../../../theme'

const Main = styled.section`
  padding: ${layout.section};
  background: ${colors.ink};
  color: ${colors.white};
`

const Container = styled.div`
  max-width: ${layout.maxWidth};
  margin: auto;
`

const Head = styled.div`
  max-width: 46rem;
  margin-bottom: 2.5rem;

  .kicker {
    color: ${colors.yellow};
    font-weight: 800;
    font-size: 0.82rem;
    letter-spacing: 1px;
    text-transform: uppercase;
    margin-bottom: 0.5rem;
  }

  h2 {
    font-size: 2.1rem;
    margin: 0 0 0.6rem;
    line-height: 1.15;

    @media (max-width: ${bp.mobile}) {
      font-size: 1.7rem;
    }
  }

  p {
    margin: 0;
    color: rgba(255, 255, 255, 0.78);
    font-size: 1.05rem;
    line-height: 1.65;
  }
`

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1.25rem;

  @media (max-width: ${bp.tablet}) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: ${bp.mobile}) {
    grid-template-columns: 1fr;
  }
`

const Stat = styled.div`
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: ${layout.radius};
  padding: 1.5rem;

  h3 {
    margin: 0;
    font-size: 2rem;
    color: ${colors.yellow};
  }

  p {
    margin: 0.4rem 0 0;
    color: rgba(255, 255, 255, 0.8);
    font-size: 0.9rem;
    line-height: 1.45;
  }
`

const Sdg = styled.div`
  margin-top: 2rem;
  display: flex;
  flex-wrap: wrap;
  gap: 0.6rem;
  align-items: center;

  .label {
    color: rgba(255, 255, 255, 0.7);
    font-weight: 700;
    font-size: 0.85rem;
    margin-right: 0.35rem;
  }

  span {
    background: rgba(255, 255, 255, 0.08);
    border-radius: 8px;
    padding: 0.35rem 0.7rem;
    font-size: 0.82rem;
    color: rgba(255, 255, 255, 0.85);
  }
`

// Sourced from the profile's Climate Impact & SDG Alignment section (assets/).
const stats = [
  { n: '50–70%', label: 'Plastic bottle usage reduction' },
  { n: '30–50%', label: 'Detergent wastage reduction' },
  { n: 'Up to 40%', label: 'Packaging cost reduction' },
  { n: '8k–12k T', label: 'Plastic waste avoided over 5 years' },
]

const sdgs = ['SDG 3', 'SDG 6', 'SDG 9', 'SDG 11', 'SDG 12', 'SDG 13']

const Impact = () => (
  <Main id="impact">
    <Container>
      <Head>
        <div className="kicker">Climate Impact</div>
        <h2>A cleaning company that is also an environmental one</h2>
        <p>
          The refill-based EcoSmart Dispenser model eliminates single-use plastic from the
          detergent supply chain — cutting cost and waste while widening access to quality
          hygiene for base-of-pyramid communities.
        </p>
      </Head>

      <Grid>
        {stats.map((s) => (
          <Stat key={s.label}>
            <h3>{s.n}</h3>
            <p>{s.label}</p>
          </Stat>
        ))}
      </Grid>

      <Sdg>
        <span className="label">SDG Alignment:</span>
        {sdgs.map((s) => (
          <span key={s}>{s}</span>
        ))}
      </Sdg>
    </Container>
  </Main>
)

export default Impact
